<template>
  <section id="forgot-donor-id-section" class="section-scc-portal container">
    <b-alert
        class="message-banner"
        :show="messages.showMessage"
        :variant="messages.variant"
        dismissible
        @dismissed="messages.showMessage=false"
    >
      <span class="span-login-page">
        {{ messages.message }}
      </span>
    </b-alert>
    <form
        @submit.prevent="actionGetDonorId"
        id="form-forgot-donor-id-portal-scc"
        :model="forgotInformation"
    >
      <p class="p-section">Please provide following details in order to get your Donor ID.</p>
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="email-forgot-donor-id">Email:</label>
          <input
              type="email"
              class="form-control input-form-css"
              :class="{'errorInput':objInvalid.invalidLogin}"
              id="email-forgot-donor-id"
              aria-describedby="emailHelp"
              v-model.trim="forgotInformation.email"
          >
          <small id="emailHelp" class="form-text text-muted">Required field.</small>
        </div>
        <div class="container-input-form container-input-form-left col-sm">
        </div>
      </div>
      <div class="row container-item-form" style="text-align: center">
        <button
            type="submit"
            class="button-section btn"
        >
          SEND DONOR ID
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: "ldForgotDonorId",
  data(){
    return{
      messages:{
        showMessage: false,
        messageFailSendEmail: false,
        variant: '',
        message: '',
      },
      forgotInformation: {
        email: '',
        requestDonorId: '',
      },
      objInvalid: {
        invalidEmail: false,
      },
    }
  },
  methods:{
    async actionGetDonorId (){

      if (!this.forgotInformation.email) {
        this.messages.message = 'The Email field is required.';
        this.messages.showMessage = true;
        this.messages.variant = 'danger';
        return;
      }

      const dataForgotDonorId = {
        email_account: this.$store.getters["communication/emailSettings"].emailUserId,
        sendTo: this.forgotInformation.email
      }

      this.$root.$emit("showSpinner");
      const getForgotDonorId = await this.$store.dispatch('auth/SET_forgotDonorId', dataForgotDonorId)
      this.$root.$emit("hideSpinner");

      if(!getForgotDonorId.result.result){
        this.messages.message = getForgotDonorId.result.message
        this.messages.showMessage = true
        this.messages.variant = 'danger'
      } else {
        this.messages.message = 'A new password has been sent to your email.'
        this.messages.showMessage = true
        this.messages.variant = 'success'
        await this.$router.push({name: 'loginDonor'})
      }
    }
  },
}
</script>

<style scoped>
  .span-login-page{
    white-space: pre-line
  }
</style>
